import { useEffect } from 'react';
import { listenTripAlertsAnalysis } from '../../channels/tripAlertsAnalysisChannel';
import { useTripAlertsAnalysisStore } from '../../stores/analysis/useTripAlertsAnalysisStore';

export function useTripAlertsAnalysisChannel() {

    useEffect(() => {

        const unsubscribe = listenTripAlertsAnalysis(({ tipo, payload }) => {

            const {
                setAlert,
                setAlertsBatch,
                deleteAlert
            } = useTripAlertsAnalysisStore.getState();

            if (tipo === 'trip-alert-analysis-upsert') {
                setAlert(payload, false);
            }

            if (tipo === 'trip-alert-analysis-batch-upsert') {
                setAlertsBatch(payload, false);
            }

            if (tipo === 'trip-alert-analysis-delete') {
                deleteAlert(payload.date, payload.codigo, false);
            }

        });

        return unsubscribe;

    }, []);

}